/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_DurationInputs */

const en_us2_search_field_duration = /** @type {(inputs: Search_Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout length`)
};

const pt_br2_search_field_duration = /** @type {(inputs: Search_Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração do treino`)
};

const es_419_search_field_duration = /** @type {(inputs: Search_Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración del entrenamiento`)
};

const pt_pt2_search_field_duration = /** @type {(inputs: Search_Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração do treino`)
};

const fr_fr2_search_field_duration = /** @type {(inputs: Search_Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée de la séance`)
};

const de_de2_search_field_duration = /** @type {(inputs: Search_Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainingsdauer`)
};

const it_it2_search_field_duration = /** @type {(inputs: Search_Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata dell'allenamento`)
};

/**
* | output |
* | --- |
* | "Workout length" |
*
* @param {Search_Field_DurationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_duration = /** @type {((inputs?: Search_Field_DurationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_DurationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_duration(inputs)
	if (locale === "es-419") return es_419_search_field_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_duration(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_duration(inputs)
	if (locale === "de-DE") return de_de2_search_field_duration(inputs)
	if (locale === "it-IT") return it_it2_search_field_duration(inputs)
	return en_us2_search_field_duration(inputs)
});
export { search_field_duration as "search.field_duration" }